// Chat side panel
// (WEB-8005). Composed by praxisStyles.ts at the section's original
// position — source order is part of the cascade.
export const praxisSidePanel = `
/* Side panel */
.pr-side-panel-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 14px 14px 20px;
  border-bottom: 1px solid var(--pr-hairline);
  flex-shrink: 0;
  background: var(--pr-bg);
}
.pr-side-panel-title {
  display: flex; align-items: baseline; gap: 8px;
  font-size: 13px; font-weight: 600; color: var(--pr-ink);
}
.pr-exhibit-tag {
  font-family: var(--pr-font-mono);
  font-size: 10px;
  color: var(--pr-ink-4);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
`;
